import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
	CreateProductionCatalogInput,
	CreateProductionItemInput,
	MergeProductionCategoryInput
} from "~/gql/graphqlBase.generated";

interface ItemsManagementState {
	catalogFormOpen: boolean;
	categoryFormOpen: boolean;
	createProductionCatalogInput?: CreateProductionCatalogInput;
	createProductionCategoryInput?: MergeProductionCategoryInput;
	createProductionItemInput?: CreateProductionItemInput;
	itemFormOpen: boolean;
}

const initialState: ItemsManagementState = {
	catalogFormOpen: false,
	categoryFormOpen: false,
	itemFormOpen: false
};

export const itemsManagementSlice = createSlice({
	initialState,
	name: "itemsManagement",
	reducers: {
		closeCatalogForm: (state) => {
			state.catalogFormOpen = false;
		},
		closeCategoryForm: (state) => {
			state.categoryFormOpen = false;
		},
		closeItemForm: (state) => {
			state.itemFormOpen = false;
		},
		openCatalogForm: (state) => {
			state.catalogFormOpen = true;
		},
		openCategoryForm: (state) => {
			state.categoryFormOpen = true;
		},
		openItemForm: (state) => {
			state.itemFormOpen = true;
		},
		setCreateProductionCatalogInput: (state, action: PayloadAction<CreateProductionCatalogInput | null>) => {
			if (action.payload === null) {
				state.createProductionCatalogInput = undefined;
				return;
			}
			state.createProductionCatalogInput = { ...action.payload };
		},
		setCreateProductionCategoryInput: (state, action: PayloadAction<MergeProductionCategoryInput | null>) => {
			if (action.payload === null) {
				state.createProductionCategoryInput = undefined;
				return;
			}
			state.createProductionCategoryInput = { ...action.payload };
		},
		setCreateProductionItemInput: (state, action: PayloadAction<CreateProductionItemInput | null>) => {
			if (action.payload === null) {
				state.createProductionItemInput = undefined;
				return;
			}
			state.createProductionItemInput = { ...action.payload };
		},
		updateCreateProductionCatalogInput: (
			state,
			action: PayloadAction<Partial<CreateProductionCatalogInput> | null>
		) => {
			if (action.payload === null) {
				state.createProductionCatalogInput = undefined;
				return;
			}
			if (!state.createProductionCatalogInput) return;
			state.createProductionCatalogInput = {
				...state.createProductionCatalogInput,
				...action.payload
			};
		},
		updateCreateProductionCategoryInput: (
			state,
			action: PayloadAction<Partial<MergeProductionCategoryInput> | null>
		) => {
			if (action.payload === null) {
				state.createProductionCategoryInput = undefined;
				return;
			}
			if (!state.createProductionCategoryInput) return;
			state.createProductionCategoryInput = {
				...state.createProductionCategoryInput,
				...action.payload
			};
		},
		updateCreateProductionItemInput: (state, action: PayloadAction<Partial<CreateProductionItemInput> | null>) => {
			if (action.payload === null) {
				state.createProductionItemInput = undefined;
				return;
			}
			if (!state.createProductionItemInput) return;
			state.createProductionItemInput = {
				...state.createProductionItemInput,
				...action.payload
			};
		}
	}
});

export const {
	closeCatalogForm,
	closeCategoryForm,
	closeItemForm,
	openCatalogForm,
	openCategoryForm,
	openItemForm,
	setCreateProductionCatalogInput,
	setCreateProductionCategoryInput,
	setCreateProductionItemInput,
	updateCreateProductionCatalogInput,
	updateCreateProductionCategoryInput,
	updateCreateProductionItemInput
} = itemsManagementSlice.actions;

export default itemsManagementSlice.reducer;
